import { isNumber } from "../../omnia"
import { INtrReq, NutrientType } from "../../types"

export type NutrientDef = ReturnType<typeof getNutrientDef>

export const getNutrientDefs = () => [

    getNutrientDef(NutrientType.N, "N", r => r.NCalcStatusText),
    getNutrientDef(NutrientType.SO3, "SO<sub>3</sub>", r => r.NCalcStatusText, {
        noOpeningBalance: true
    }),

    getNutrientDef(NutrientType.P2O5, "P<sub>2</sub>O<sub>5</sub>", r => r.PkCalcStatusText),
    getNutrientDef(NutrientType.K2O, "K<sub>2</sub>O", r => r.PkCalcStatusText),
    getNutrientDef(NutrientType.MgO, "MgO", r => r.PkCalcStatusText),

    getNutrientDef(NutrientType.Lime, "pH / Lime", r => r.LimeCalcStatusText, {
        noOpeningBalance: true,
        tonnesPerHa: false,
        analysisAttribute: "pH",
        rounding: 0
    }),

]

interface INutrientDefOptions {
    noOpeningBalance?: boolean;
    tonnesPerHa?: boolean;
    analysisAttribute?: string;
    rounding?: number;
}

export function getNutrientDef(
    _nutrient: NutrientType,
    _htmlText: string,
    _calcStatusProvider: (req: INtrReq) => string,
    _options: INutrientDefOptions = {}
) {

    const _key = NutrientType[_nutrient]
    const _rounding = isNumber(_options.rounding) ? _options.rounding : 1

    return {

        get nutrientType() {
            return _nutrient
        },

        get key(): string {
            return _key
        },

        get htmlText() {
            return _htmlText
        },

        get tonnesPerHa() {
            return _options.tonnesPerHa;
        },

        get hasOpeningBalance() {
            return !_options.noOpeningBalance;
        },

        getCalcStatus(req: INtrReq) {
            return _calcStatusProvider(req)
        },

        get analysisAttribute() {
            return _options.analysisAttribute || _key
        },

        get rounding() {
            return _rounding
        },

    }
}
